module.exports = __webpack_public_path__ + "static/sp_sm_2-86430a324abeeb2846d91533c41494cf.jpg";